import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router/types/router';
import _ from 'lodash';

@Component<MiElementPanelTabbed>({})
export default class MiElementPanelTabbed extends Vue {
  @Prop({ default: () => [] })
  protected tabs!: Tab[];

  @Prop({ default: true })
  protected collapse!: boolean;

  @Prop({ default: 4 })
  protected elevation!: number;

  @Prop({ default: '' })
  protected startTab!: string;

  @Prop({ default: 0 })
  protected depth!: number;

  protected urlPath = '';

  protected currentTab: string = this.startTab;

  protected mounted(): void {
    this.createUrlPath();
  }

  protected createUrlPath(): void {
    const urlParts = window.location.pathname.split('/');
    const urlPathParts: string[] = [];
    for (let i = 1; i <= this.depth; i += 1) {
      urlPathParts.push(urlParts[i]);
    }
    this.urlPath = `/${urlPathParts.join('/')}`;
  }

  protected getTabTitle(tab: Tab): string {
    if (tab.name) { return tab.name; }
    return _.startCase(tab.key);
  }

  protected urlPathChanged(fromUrlParts: string[], toUrlParts: string[]): boolean {
    for (let i = 1; i <= this.depth; i += 1) {
      if (fromUrlParts[i] !== toUrlParts[i]) { return true; }
    }
    return false;
  }

  protected isNavigatingBackwards(fromUrlParts: string[], toUrlParts: string[]): boolean {
    return (fromUrlParts.length === (this.depth + 2) && toUrlParts.length === (this.depth + 1));
  }

  @Watch('$route')
  protected routeChanged(to: Route, from: Route): void {
    const fromUrlParts = from.fullPath.split('/');
    const toUrlParts = to.fullPath.split('/');

    if (this.urlPathChanged(fromUrlParts, toUrlParts)) { return; }

    if (this.isNavigatingBackwards(fromUrlParts, toUrlParts)) {
      this.$router.back();
    }
  }
}

export interface Tab {
  name?: string;
  key?: string;
}
